module.exports = __webpack_public_path__ + "img/coffee_desktop_low.d272635e.jpg";